<nav aria-label="breadcrumb" class="xng-breadcrumb-root" [ngClass]="class">
  <ol class="xng-breadcrumb-list">
    <ng-container
      *ngFor="
        let segment of segments$ | async;
        last as isLast;
        first as isFirst;
        index as index;
        count as count
      "
    >
      <li class="xng-breadcrumb-item">
        <button
          *ngIf="segment.ellipsis"
          (click)="expand()"
          type="button"
          class="xng-breadcrumb-ellipsis"
          aria-label="Показать скрытые уровни"
        >
          …
        </button>

        <ng-container *ngIf="!segment.ellipsis">
          <a
            *ngIf="!isLast"
            (click)="handleRoute(segment.breadcrumb)"
            (keydown.enter)="handleRoute(segment.breadcrumb)"
            class="xng-breadcrumb-link"
            [ngClass]="{ 'xng-breadcrumb-link-disabled': segment.breadcrumb.disable }"
            [attr.aria-disabled]="segment.breadcrumb.disable"
            [attr.tabIndex]="segment.breadcrumb.disable ? -1 : 0"
            role="button"
          >
            <ng-container
              *ngTemplateOutlet="
                itemTemplate;
                context: {
                  $implicit: segment.breadcrumb.label,
                  info: segment.breadcrumb.info,
                  last: isLast,
                  first: isFirst,
                  index: index,
                  count: count
                }
              "
            ></ng-container>
            <ng-container *ngIf="!itemTemplate">{{
              segment.breadcrumb.label
              }}</ng-container>
          </a>

          <label *ngIf="isLast" class="xng-breadcrumb-trail" aria-current="page">
            <ng-container
              *ngTemplateOutlet="
                itemTemplate;
                context: {
                  $implicit: segment.breadcrumb.label,
                  info: segment.breadcrumb.info,
                  last: isLast,
                  first: isFirst,
                  index: index,
                  count: count
                }
              "
            ></ng-container>
            <ng-container *ngIf="!itemTemplate">{{
              segment.breadcrumb.label
              }}</ng-container>
          </label>
        </ng-container>
      </li>

      <li
        *ngIf="!isLast"
        class="xng-breadcrumb-separator"
        aria-hidden="true"
        role="separator"
      >
        <ng-container *ngTemplateOutlet="separatorTemplate"></ng-container>
        <ng-container *ngIf="!separatorTemplate">{{ separator }}</ng-container>
      </li>
    </ng-container>
  </ol>
</nav>
